import React, { Fragment, useContext, useState } from "react";
import Cookies from "js-cookie";
import { DropdownToggle, DropdownMenu, Nav, NavItem, UncontrolledButtonDropdown } from "reactstrap";
import { faAngleDown, faUserDoctor } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-toastify/dist/ReactToastify.css";
import { ProfileContext } from "../contexts/ProfileContext";
import { Button } from "react-bootstrap";
import makeFirstLetterCap from "./FirstLetterCap";

export default function UserBox() {
  const { logout, profile } = useContext(ProfileContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    Cookies.remove("authToken");
    Cookies.remove("userRoles");
    window.location.reload();
  };
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  return (
    <Fragment>
      <div className="header-btn-lg pe-0">
        <div className="widget-content p-0">
          <div className="widget-content-wrapper">
            <div className="widget-content-left">
              <UncontrolledButtonDropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <div className="widget-content-right me-3 header-user-info">
                  {profile ? <div className="widget-heading">{profile?.name}</div> : null}
                  <div className="widget-subheading">
                    {profile && profile?.roles?.length > 0
                      ? profile.roles.map((role, index) => {
                          if (index > 0) return `, ${makeFirstLetterCap(role)}`;
                          return ` ${makeFirstLetterCap(role)}`;
                        })
                      : null}
                    {/* {"Admin"} */}
                  </div>
                </div>
                <DropdownToggle color="link" className="p-0 d-flex align-items-center">
                  {/* <img className="avatar" width={30} alt="" src={profile?.profile_pic} /> */}
                  <FontAwesomeIcon className="text-secondary fs-3 icon-hover" icon={faUserDoctor} />
                  <FontAwesomeIcon className="ms-2 opacity-8 text-secondary" icon={faAngleDown} />
                </DropdownToggle>
                <DropdownMenu end className="rm-pointers dropdown-menu">
                  <Nav vertical>
                    {/* <NavItem>
                      <Button
                        variant="primary"
                        onClick={() => {
                          setModalShow(true);
                          closeDropdown();
                        }}
                        className={`user-btn text-secondary ${checkIsAdmin() ? "" : "d-none"}`}
                      >
                        Add User
                      </Button>
                    </NavItem> */}
                    {/* <NavItem>
                      <Button
                        variant="primary"
                        onClick={() => {
                          setModalSetting(true);
                          closeDropdown();
                        }}
                        className="user-btn text-secondary"
                      >
                        Settings
                      </Button>
                      <UserSetting show={modalSetting} onHide={() => setModalSetting(false)} />
                    </NavItem> */}
                    <NavItem>
                      <Button
                        className="user-btn text-danger"
                        onClick={() => {
                          handleLogout();
                          closeDropdown();
                        }}
                      >
                        Log Out
                      </Button>
                    </NavItem>
                  </Nav>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
